/* jslint esversion: 6 */
/**
 * Max-Width Table
 *
 * Enable tables to scroll within a max-width container element.
 *
 * @requires styles _a-min-width-table.scss
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
  scope: $('.main'), // $('main'),
  selector: 'table',
  exclude: [ // valid :not selectors
    'table table',
    // 'table:nth-child(2)',
    // '[class^="gfield_list"]',
  ],
};

function init() {

  $(wrapTables).promise().done(function() {
    events();
  });
}

function events() {

  $(window).on('load resize', function() {

    $('.a-min-width-table').each(function() {
      const $container      = $(this);
      const $containerInner = $container.children('.a-min-width-table__inner');

      const $scrollable = $containerInner;

      setShadows($container);

      $scrollable.on('scroll', function() {
        setShadows($container);
      });
    });
  });
}

function wrapTables() {

  if (s.exclude.length) {
    s.exclude.forEach(function(value, key) {
      s.selector += ':not(' + value + ')';
    });
  }

  s.scope.find(s.selector).each(function() {
    const table = $(this);
    table.next(':empty').remove(); // remove WordPress/Tiny MCE habit of adding an empty line/paragraph after a table
    // table.wrap('<div class="a-min-width-table"></div>');
    // table.wrap('<div class="a-min-width-table__inner"></div>');
    table.wrap('<div class="a-min-width-table"><div class="a-min-width-table__inner">');
  });
}

function setShadows(element) {
  const $container      = $(element);
  const $containerInner = $container.children('.a-min-width-table__inner');

  const $scrollable = $containerInner;

  const $table = $container.find('table');

  const widthScrollable = Math.floor(parseFloat($scrollable.css('width')));
  const widthTable      = Math.floor(parseFloat($table.css('width')));

  if (widthTable > widthScrollable) {

    if ($scrollable.scrollLeft() > 3) {
      $container.addClass('a-min-width-table--scrollable-left');
    }
    else {
      $container.removeClass('a-min-width-table--scrollable-left');
    }

    if ($scrollable.scrollLeft() < (widthTable - widthScrollable - 3)) {
      $container.addClass('a-min-width-table--scrollable-right');
    }
    else {
      $container.removeClass('a-min-width-table--scrollable-right');
    }
  }
  else {
    $container.removeClass('a-min-width-table--scrollable-left');
    $container.removeClass('a-min-width-table--scrollable-right');
  }
}

export {init as default};
